import React, { useMemo } from "react";
import { createBrowserRouter, RouterProvider, ScrollRestoration } from "react-router-dom";
import Layout from "./components/Layout";
import { SmoothScroll } from "./components/Motion";
import Home from "./pages/Home";
import MenuPage from "./pages/Menu";
import TentangPage from "./pages/Tentang";
import LokasiPage from "./pages/Lokasi";
import KontakPage from "./pages/Kontak";
import FaqPage from "./pages/Faq";
import NotFound from "./pages/NotFound";

export const routes = [
  {
    element: (
      <>
        <ScrollRestoration />
        <Layout />
      </>
    ),
    children: [
      { path: "/", element: <Home /> },
      { path: "/menu/", element: <MenuPage /> },
      { path: "/tentang/", element: <TentangPage /> },
      { path: "/lokasi/", element: <LokasiPage /> },
      { path: "/kontak/", element: <KontakPage /> },
      { path: "/faq/", element: <FaqPage /> },
      { path: "*", element: <NotFound /> },
    ],
  },
];

export default function App() {
  const router = useMemo(() => createBrowserRouter(routes), []);
  return (
    <>
      <SmoothScroll />
      <RouterProvider router={router} />
    </>
  );
}
